import { Navigate } from 'react-router-dom';
import { useAdmin } from '../../hooks/useAdmin';
import { useAuthStore } from '../../store/authStore';

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const user = useAuthStore(s => s.user);
  const { isAdmin, loading } = useAdmin();

  if (!user) return <Navigate to="/login" replace />;

  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-gray-950">
        <div className="flex flex-col items-center gap-4">
          <div className="relative w-10 h-10">
            <div className="absolute inset-0 rounded-full border-4 border-gray-700" />
            <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-indigo-500 animate-spin" />
          </div>
          <p className="text-gray-400 text-sm">Checking access...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) return <Navigate to="/" replace />;

  return <>{children}</>;
}
